import * as React from 'react';

const RfidSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            d="M13.429 12c0-.78-.641-1.414-1.429-1.414s-1.429.634-1.429 1.414c0 .78.641 1.414 1.429 1.414s1.429-.634 1.429-1.414zm.952 0c0 1.3-1.068 2.357-2.381 2.357-1.313 0-2.381-1.058-2.381-2.357 0-1.3 1.068-2.357 2.381-2.357 1.313 0 2.381 1.058 2.381 2.357zm1.323-3.666a5.148 5.148 0 010 7.332l.673.667a6.083 6.083 0 000-8.666l-.673.667zm-8.081-.667a6.083 6.083 0 000 8.666l.673-.667a5.148 5.148 0 010-7.332l-.673-.667zM19.07 5l-.673.667a8.893 8.893 0 010 12.666l.673.667a9.83 9.83 0 000-14zm-13.47.667a8.893 8.893 0 000 12.666L4.93 19a9.83 9.83 0 010-14l.673.667z"
        />
    </svg>
);

RfidSvg.displayName = 'RfidSvg';
export default RfidSvg;
